module.exports = __webpack_public_path__ + "static/media/parameters.bda69364.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/parameters.png
// module id = 413
// module chunks = 0